import { IAppProviderState } from '../interface/IAppProvider';

export type ChangesType = Partial<IAppProviderState>;

export const appContextReducer = (state: IAppProviderState, changes: ChangesType): IAppProviderState => {
    return { ...state, ...changes };
};
